const chatbot = {
  CHATBOT_MESSAGE_WELCOME:
    "Welcome to the Plika chat! 👋 I'm a virtual assistant, and I can hook you up with all the deets about the platform.",
  CHATBOT_MESSAGE_HELP: 'How can I help you out?',
}

export default chatbot
